let accordionList, buttonArr, contentContainerArr, selectedId;

const openPanel = e => {
    e.preventDefault();
    const clickedId = e.target.getAttribute('data-button-id');
    if (clickedId && clickedId !== selectedId) {
        selectedId = clickedId;
        contentContainerArr.map(container => {
            const contentId = container.getAttribute('data-post-id');
            if (contentId === clickedId) {
                container.classList.add('accordion__content--selected');
                container.style.height = 'auto';
                const height = container.clientHeight + 'px';
                container.style.height = '0px';
                setTimeout(function() {
                    container.style.height = height;
                }, 10);
            } else {
                container.style.height = '0px';
                setTimeout(() => {
                    // need to setTimeout to wait for CSS transition to finish
                    container.classList.remove('accordion__content--selected');
                }, 300);
            }
        });
        // add "--selected" class to active button
        buttonArr.map(button => {
            const buttonId = button.getAttribute('data-button-id');
            const listItemParent = button.closest('.accordion__list-item');
            if (buttonId === clickedId) {
                listItemParent.classList.add('accordion__list-item--selected');
            } else {
                listItemParent.classList.remove('accordion__list-item--selected');
            }
        });
    }
};

export const addAccordionListeners = () => {
    accordionList = document.querySelector('.accordion__list');
    if (accordionList) {
        accordionList.addEventListener('click', openPanel);
        accordionList.addEventListener('touchend', openPanel);
        const contentContainers = document.querySelectorAll('.accordion__content');
        contentContainerArr = Array.from(contentContainers);
        const listButtons = document.querySelectorAll('.accordion__button');
        buttonArr = Array.from(listButtons);
    }
};

export const removeAccordionListeners = () => {
    accordionList = document.querySelector('.accordion__list');
    if (accordionList) {
        accordionList.removeEventListener('click', openPanel);
        accordionList.removeEventListener('touchend', openPanel);
    }
};

addAccordionListeners();
